import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../../../config/config.js";
import { useParams } from "react-router-dom";

import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import Button from "@mui/joy/Button";

import Regionales from "./Instituciones/Regionales/Regionales";
import Regionales2 from "./Instituciones/Regionales/Regionales2";
import ParticipantesRugby from "./Instituciones/Participantes/ParticipantesRugby";
import Grupos from "./Grupos/Grupos";
import Fixture from "./Fixture/Fixture";
import Fixture2 from "./Fixture/Fixture2";
import Fixture3 from "./Fixture/Fixture3";

// toast
import { toast } from "react-hot-toast";
import { FaExternalLinkAlt } from "react-icons/fa";
import { FaWandMagicSparkles } from "react-icons/fa6";
import { GiPerspectiveDiceSixFacesRandom } from "react-icons/gi";
import { FaObjectGroup } from "react-icons/fa6";

// utils
import { randomSembradoRegion } from "../../../utils/randomSembradoUtils.js";
import { getColorById } from "../../../utils/colorSport.js";
import { FaDatabase } from "react-icons/fa";

import { randomSembradoEspecialFutbolDamas } from "../../../utils/randomSembradoEspecialFutbolDamas.js";

import "./FullScreenGrupos.css";

const FullScreenGrupos = ({ open, setOpen }) => {
  const [configCtg, setConfigCtg] = useState({});
  const [participantes, setParticipantes] = useState([]);
  const [fixtures, setFixtures] = useState([]);
  const [color, setColor] = useState("#8634eb"); // Color por defecto
  const [confirmOpen, setConfirmOpen] = useState(false); // Estado del modal de confirmación
  const [sport, setSport] = useState(null);
  const [event, setEvent] = useState(null);
  const [sembradoUpdated, setSembradoUpdated] = useState(false);
  const [groupSizes, setGroupSizes] = useState([]);

  const flag6 = true;

  const [customConfigOpen, setCustomConfigOpen] = useState(false); // Estado del modal de configuración
  const [customRegions, setCustomRegions] = useState(""); // Estado para los valores personalizados del textarea
  const [customGroupCount, setCustomGroupCount] = useState(6); // Estado para la cantidad de grupos

  const { idevent, idsport } = useParams();

  useEffect(() => {
    const fetchDatos = async () => {
      try {
        let event = await axios.get(
          `${API_BASE_URL}/championship/?idevent=${idevent}`
        );
        setEvent(event.data);

        let sport = await axios.get(
          `${API_BASE_URL}/sport/?idsport=${idsport}`
        );
        setSport(sport.data);
      } catch (error) {
        console.error("Error fetching datos", error);
      }
    };
    if (idsport) {
      fetchDatos();
    }
  }, [idsport]);

  useEffect(() => {
    const getConfigCategory = async () => {
      const response = await axios.post(`${API_BASE_URL}/config_category`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
      });
      console.log("configuracion", response.data);
      setConfigCtg(response.data);

      // Verificar si 'configuracion_sembrado_region' tiene un valor válido y no es nulo o vacío
      if (response.data.configuracion_sembrado_region) {
        setCustomRegions(response.data.configuracion_sembrado_region); // Establecer el valor predeterminado en el input
      }
    };

    if (idevent && idsport) {
      getConfigCategory();
    }
  }, [idevent, idsport]);

  useEffect(() => {
    const getDatos = async () => {
      const responseFixture = await axios.post(`${API_BASE_URL}/getfixture`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
      });
      setFixtures(responseFixture.data);

      const responseParticipantes = await axios.post(
        `${API_BASE_URL}/getparticipantsregion`,
        {
          idevent: Number(idevent),
          idsport: Number(idsport),
          idtypephase: 1,
        }
      );
      setParticipantes(responseParticipantes.data);
    };
    getDatos();
  }, [idevent, idsport]);

  useEffect(() => {
    if (idsport) {
      // setColor(getColorById(Number(idsport)));
      setColor(sport ? sport.color : getColorById(Number(idsport)));
    }
  }, [idsport]);

  // Nueva función para asignar tamaños aleatorios de grupos
  // const handleAssignRandomGroupSizes = () => {
  //   const totalGroups = configCtg.nro_grupos; // Total de grupos (por ejemplo, 6)
  //   const totalParticipants = configCtg.nro_instituciones_participantes; // Total de participantes (por ejemplo, 20)

  //   // Calcular el tamaño base de los grupos
  //   const baseGroupSize = Math.floor(totalParticipants / totalGroups); // Tamaño base por grupo
  //   const groupsWithExtra = totalParticipants % totalGroups; // Grupos que tendrán un participante adicional

  //   // Crear el array que representa la cantidad de equipos por grupo
  //   const groupSizes = Array(totalGroups).fill(baseGroupSize);

  //   // Asignar el participante adicional a algunos grupos aleatoriamente
  //   for (let i = 0; i < groupsWithExtra; i++) {
  //     groupSizes[i]++;
  //   }

  //   // Mezclar el array para asignar aleatoriamente los tamaños de los grupos
  //   for (let i = groupSizes.length - 1; i > 0; i--) {
  //     const j = Math.floor(Math.random() * (i + 1));
  //     [groupSizes[i], groupSizes[j]] = [groupSizes[j], groupSizes[i]];
  //   }

  //   setGroupSizes(groupSizes); // Guardar el tamaño de los grupos en el estado
  //   toast.success("¡Tamaños de grupos asignados aleatoriamente!");
  // };

  // Función para asignar tamaños aleatorios de grupos
  const handleAssignRandomGroupSizes = () => {
    const totalGroups = Number(configCtg.nro_grupos) || 0;
    const totalParticipants = Number(configCtg.nro_instituciones_participantes) || 0;

    if (totalGroups <= 0) return;

    // Tamaño base y residuo
    const baseGroupSize = Math.floor(totalParticipants / totalGroups);
    const groupsWithExtra = totalParticipants % totalGroups;

    // Inicializa todos con el base
    const groupSizes = Array(totalGroups).fill(baseGroupSize);

    // Suma +1 a los últimos 'groupsWithExtra' grupos
    // Ej.: si son 5 grupos y residuo=2, se incrementan índices 3 y 4 (D y E)
    for (let i = totalGroups - groupsWithExtra; i < totalGroups; i++) {
      if (i >= 0 && i < totalGroups) groupSizes[i] += 1;
    }

    setGroupSizes(groupSizes);
    toast.success("¡Tamaños de grupos asignados!");
  }

  const handleConfirmOpen = () => {
    setConfirmOpen(true);
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
  };

  const handleCustomConfigOpen = () => {
    setCustomConfigOpen(true);
  };

  const handleCustomConfigClose = () => {
    setCustomConfigOpen(false);
  };
  const handleSaveCustomConfig = () => {
    const parsedConfig = parseInputToRegions(customRegions); // Usar la nueva función de parseo

    if (parsedConfig) {
      const { regions, groupCount } = parsedConfig; // Obtener regiones y cantidad de grupos

      // Guardar la configuración en el estado de la aplicación en el formato JSON original para otros usos
      setCustomRegions(customRegions); // Mantener la cadena de entrada en el estado (en su formato de cadena)
      setCustomGroupCount(groupCount); // Guardar la cantidad de grupos
      handleCustomConfigClose();
      toast.success("¡Configuración personalizada guardada!");
    }
  };

  const generateMatches = async () => {
    if (configCtg.usePreMatch) {
      // Lógica para actualizar los pre-matches
      try {
        console.log("participantes", participantes);

        // Obtener los preMatches del backend
        const responsePreMatches = await axios.post(
          `${API_BASE_URL}/getmatches`,
          {
            idevent: Number(idevent),
            idsport: Number(idsport),
          }
        );

        const preMatches = responsePreMatches.data;
        console.log("Pre Matches", preMatches);

        // Mapeo de los preMatches para obtener la estructura necesaria para la actualización
        const matches = preMatches.map((match) => ({
          idmatch: match.idmatch,
          idgrupo: match.idgrupo,
          pos1_prematch: match.pos1_prematch,
          pos2_prematch: match.pos2_prematch,
          idevent: Number(idevent),
          idsport: Number(idsport),
        }));

        // Envío de los matches actualizados al backend para que se actualicen los participantes
        const response = await axios.patch(
          `${API_BASE_URL}/patchprematches`,
          matches
        );

        console.log("Matches actualizados", response);
        toast.success("¡Enfrentamientos actualizados exitosamente!");
      } catch (error) {
        toast.error("¡Hubo un problema al actualizar los matches!");
        console.error("Error al actualizar matches", error);
      }
    } else {
      /* ============================================================ */
      /* 0. Agrupar participantes por grupo                          */
      /* ============================================================ */
      const groupedParticipants = participantes.reduce((acc, p) => {
        (acc[p.idgrupo] ??= []).push(p);
        return acc;
      }, {});
      console.log("participantes por grupo", groupedParticipants);
      console.log("fixtures BD", fixtures);

      /* ============================================================ */
      /* 1. Configuración ‘lottery’                                  */
      /* ============================================================ */
      const flag_use_lottery = false; // ← cambia a false para usar fixtures de BD
      const flag_doble_ronda = Number(configCtg.nro_rondas) === 2 ? true : false;
      // Fixtures fijos para 3 y 4 equipos (mismo calendario, con “4” como placeholder de bye)
      const FIXTURE3 = [
        { fecha: 1, partidos: [[1, 4], [2, 3]] },
        { fecha: 2, partidos: [[3, 1], [4, 2]] },
        { fecha: 3, partidos: [[1, 2], [3, 4]] },
      ];
      const FIXTURE4 = FIXTURE3;

      const globalCalendars = {
        3: flag_use_lottery ? FIXTURE3 : null,
        4: flag_use_lottery ? FIXTURE4 : null,
      };

      /* ============================================================ */
      /* 2. Construir matches                                        */
      /* ============================================================ */
      const matches = {};

      Object.keys(groupedParticipants).forEach((groupId) => {
        const gp = groupedParticipants[groupId];
        const n = gp.length;
        matches[groupId] = [];

        // Modo “lottery” fijo para 3 o 4 equipos
        if (flag_use_lottery && (n === 3 || n === 4)) {
          const calendario = globalCalendars[n];
          const map = {};
          gp.forEach((p) => (map[p.nro_grupo] = p));

          calendario.forEach(({ fecha, partidos }) => {
            partidos.forEach(([a, b], mIdx) => {
              const p1 = map[a], p2 = map[b];
              const globalIdx = (fecha - 1) * 2 + mIdx; // 0..5

              // Si uno de los dos no existe: partido de bye
              if (!p1 || !p2) {
                const byeP = p1 || p2;
                const byeLeft = mIdx % 2 === 0;
                matches[groupId].push({
                  nro_fecha: fecha,
                  nro_match: globalIdx + 1,
                  idparticipant1: byeLeft ? byeP.idparticipant : null,
                  idparticipant2: byeLeft ? null : byeP.idparticipant,
                  idparticipant_bye: byeP.idparticipant,
                  flag_bye: true,
                  idgrupo: byeP.idgrupo,
                  idevent: Number(idevent),
                  idsport: Number(idsport),
                  idtypephase: 1,
                  nro_team1: byeLeft ? (p1 ? a : b) : null,
                  nro_team2: byeLeft ? null : (p1 ? a : b),
                });
              } else {
                // Partido “real”
                matches[groupId].push({
                  nro_fecha: fecha,
                  nro_match: globalIdx + 1,
                  idparticipant1: p1.idparticipant,
                  idparticipant2: p2.idparticipant,
                  flag_bye: false,
                  state: 1,
                  idgrupo: p1.idgrupo,
                  idevent: Number(idevent),
                  idsport: Number(idsport),
                  idtypephase: 1,
                  nro_team1: a,
                  nro_team2: b,
                });
              }
            });
          });

          return; // pasar al siguiente grupo
        }

        /* ============ FIXTURE DESDE BD  =========================== */
        /* 1. Filtrar fixtures por número de equipos */
        const baseFixtures = fixtures.filter(f => f.base_fixture.nro_equipos === n);

        /* 2. Calcular cuántas fechas hay en la vuelta simple */
        const totalFechas = baseFixtures.reduce((max, fx) => Math.max(max, fx.n_fecha), 0);

        /* 3. Si doble ronda, duplicar los fixtures intercambiando local/visitante y sumando totalFechas */
        const fixturesToUse = flag_doble_ronda
          ? baseFixtures.concat(
            baseFixtures.map(fx => ({
              ...fx,
              n_fecha: fx.n_fecha + totalFechas,      // pasa a la 2ª ronda
              nro_team1: fx.nro_team2,                // swap local/visitante
              nro_team2: fx.nro_team1,
              // Si había bye, sigue siendo bye; team_bye no cambia
              flag_bye: fx.flag_bye,
              team_bye: fx.team_bye
            }))
          )
          : baseFixtures;

        /* 4. Recorres fixturesToUse en lugar de gf */
        fixturesToUse.forEach(fx => {
          if (fx.flag_bye) {
            const byeP = gp.find(p => p.nro_grupo === fx.team_bye);
            if (!byeP) return;
            matches[groupId].push({
              nro_fecha: fx.n_fecha,
              nro_match: fx.n_match,
              idparticipant1: fx.nro_team1 ? byeP.idparticipant : null,
              idparticipant2: fx.nro_team2 ? byeP.idparticipant : null,
              idparticipant_bye: byeP.idparticipant,
              flag_bye: true,
              idgrupo: byeP.idgrupo,
              idevent: +idevent,
              idsport: +idsport,
              idtypephase: 1,
              nro_team1: fx.nro_team1,
              nro_team2: fx.nro_team2,
            });
          } else {
            const t1 = gp.find(p => p.nro_grupo === fx.nro_team1);
            const t2 = gp.find(p => p.nro_grupo === fx.nro_team2);
            if (!t1 || !t2) return;
            matches[groupId].push({
              nro_fecha: fx.n_fecha,
              nro_match: fx.n_match,
              idparticipant1: t1.idparticipant,
              idparticipant2: t2.idparticipant,
              flag_bye: false,
              state: 1,
              idgrupo: t1.idgrupo,
              idevent: +idevent,
              idsport: +idsport,
              idtypephase: 1,
              nro_team1: fx.nro_team1,
              nro_team2: fx.nro_team2,
            });
          }
        });
      });

      /* ============================================================ */
      /* 3. Envío al back-end                                        */
      /* ============================================================ */
      // 1) Aplana todo
      const combinedMatches = Object.values(matches).flat();

      // 2) Orden global: primero por fecha; luego por grupo (estable);
      //    luego por el nro_match original del fixture o, si no existe,
      //    por nro_team1/nro_team2 para mantener estabilidad.
      combinedMatches.sort((a, b) => {
        const byFecha = (a.nro_fecha ?? 0) - (b.nro_fecha ?? 0);
        if (byFecha !== 0) return byFecha;

        const byGrupo = (a.idgrupo ?? 0) - (b.idgrupo ?? 0);
        if (byGrupo !== 0) return byGrupo;

        const aKey = (a.nro_match ?? a.nro_team1 ?? Number.MAX_SAFE_INTEGER);
        const bKey = (b.nro_match ?? b.nro_team1 ?? Number.MAX_SAFE_INTEGER);
        if (aKey !== bKey) return aKey - bKey;

        return (a.nro_team2 ?? 0) - (b.nro_team2 ?? 0);
      });

      // 3) Renumerar globalmente, saltando byes
      let seq = 1;
      for (const m of combinedMatches) {
        if (m.flag_bye) {
          // Si tu DB no acepta NULL, usa 0 u otro sentinela
          m.nro_match = null;
        } else {
          m.nro_match = seq++;
        }
      }

      try {
        const res = await axios.post(
          `${API_BASE_URL}/postmatches`,
          combinedMatches
        );
        console.log("Matches creados", res);
        toast.success("¡Enfrentamientos creados exitosamente!");
      } catch (err) {
        toast.error("¡Hubo un problema al crear los matches!");
        console.error("Error al crear matches", err);
      }
    }
  };


  // -----------------------------------------------------------------------------
  // Versión corregida: si solo se especifica grupoDirigido, el participante
  // ocupa **una posición libre aleatoria** dentro de ese grupo.
  // -----------------------------------------------------------------------------
  const assignRandomGroups = async () => {
    console.log("group size", groupSizes);
    console.log("participantes", participantes);

    /* -------------------------------------------------------------------------
     * Configuraciones y helpers
     * ----------------------------------------------------------------------- */
    const flag_use_group_size = true;
    const totalGroups = configCtg.nro_grupos;
    const maxGroupSize = Math.ceil(
      configCtg.nro_instituciones_participantes / totalGroups
    );

    // capacidad por grupo
    const capacities = flag_use_group_size
      ? groupSizes.slice(0, totalGroups)
      : Array(totalGroups).fill(maxGroupSize);

    // estado interno
    const groupAssignments = Array.from({ length: totalGroups }, () => []);

    // helpers
    const groupHasSameImage = (group, p) =>
      group.some((x) => x.Institution.image_path === p.Institution.image_path);

    const isPositionFree = (group, pos) =>
      !group.some((x) => x.nro_grupo === pos);

    const getRandomFreePosition = (group, capacity) => {
      const taken = new Set(group.map((x) => x.nro_grupo));
      const free = [];
      for (let i = 1; i <= capacity; i++) if (!taken.has(i)) free.push(i);
      return free[Math.floor(Math.random() * free.length)];
    };

    const getFirstFreePosition = (group, capacity) => {
      for (let i = 1; i <= capacity; i++) {
        if (isPositionFree(group, i)) return i;
      }
      return null;
    };

    /* -------------------------------------------------------------------------
     * 1) grupoDirigido + posicionDirigida  (slot exacto)
     * ----------------------------------------------------------------------- */
    participantes
      .filter((p) => p.grupoDirigido != null && p.posicionDirigida != null)
      .forEach((p) => {
        const g = p.grupoDirigido - 1;
        const pos = p.posicionDirigida;
        if (
          g >= 0 &&
          g < totalGroups &&
          groupAssignments[g].length < capacities[g] &&
          isPositionFree(groupAssignments[g], pos) &&
          !groupHasSameImage(groupAssignments[g], p)
        ) {
          groupAssignments[g].push({ ...p, idgrupo: g + 1, nro_grupo: pos });
        }
      });

    /* -------------------------------------------------------------------------
     * 2) Solo grupoDirigido  (posición aleatoria libre dentro del grupo)
     * ----------------------------------------------------------------------- */
    participantes
      .filter((p) => p.grupoDirigido != null && p.posicionDirigida == null)
      .forEach((p) => {
        const g = p.grupoDirigido - 1;
        if (
          g >= 0 &&
          g < totalGroups &&
          groupAssignments[g].length < capacities[g] &&
          !groupHasSameImage(groupAssignments[g], p)
        ) {
          const pos = getRandomFreePosition(groupAssignments[g], capacities[g]);
          groupAssignments[g].push({ ...p, idgrupo: g + 1, nro_grupo: pos });
        }
      });

    /* -------------------------------------------------------------------------
     * 3) Solo posicionDirigida  (grupo flexible, misma posición)
     * ----------------------------------------------------------------------- */
    participantes
      .filter((p) => p.grupoDirigido == null && p.posicionDirigida != null)
      .forEach((p) => {
        const pos = p.posicionDirigida;

        const candidateGroups = [...Array(totalGroups).keys()].sort((a, b) => {
          const fillA = groupAssignments[a].length / capacities[a];
          const fillB = groupAssignments[b].length / capacities[b];
          return fillA - fillB;
        });

        for (const g of candidateGroups) {
          if (
            groupAssignments[g].length < capacities[g] &&
            isPositionFree(groupAssignments[g], pos) &&
            !groupHasSameImage(groupAssignments[g], p)
          ) {
            groupAssignments[g].push({ ...p, idgrupo: g + 1, nro_grupo: pos });
            return;
          }
        }
        // si ningún grupo tiene ese slot libre, se maneja como restante
      });

    /* -------------------------------------------------------------------------
     * 4) Participantes restantes (sin restricciones)
     * ----------------------------------------------------------------------- */
    const placedIds = new Set(
      groupAssignments.flat().map((x) => x.idparticipant)
    );

    const remaining = participantes
      .filter((p) => !placedIds.has(p.idparticipant))
      .sort(() => Math.random() - 0.5);

    remaining.forEach((p) => {
      let placed = false;

      const candidates = [...Array(totalGroups).keys()].sort((a, b) => {
        const fillA = groupAssignments[a].length / capacities[a];
        const fillB = groupAssignments[b].length / capacities[b];
        return fillA - fillB;
      });

      // 4.1 intento normal
      for (const g of candidates) {
        if (
          groupAssignments[g].length < capacities[g] &&
          !groupHasSameImage(groupAssignments[g], p)
        ) {
          const pos = getFirstFreePosition(groupAssignments[g], capacities[g]);
          if (pos != null) {
            groupAssignments[g].push({ ...p, idgrupo: g + 1, nro_grupo: pos });
            placed = true;
            break;
          }
        }
      }

      // 4.2 si falló por image_path
      if (!placed) {
        const g = candidates.find(
          (idx) => groupAssignments[idx].length < capacities[idx]
        );
        if (g !== undefined) {
          const pos = getFirstFreePosition(groupAssignments[g], capacities[g]);
          if (pos != null) {
            groupAssignments[g].push({ ...p, idgrupo: g + 1, nro_grupo: pos });
          }
        }
      }
    });

    /* -------------------------------------------------------------------------
     * 5) Persistencia
     * ----------------------------------------------------------------------- */
    const participantsWithGroups = groupAssignments.flat();
    setParticipantes(participantsWithGroups);

    try {
      await axios.patch(`${API_BASE_URL}/batchupdateparticipants`, {
        participants: participantsWithGroups,
      });
      toast.success("¡Grupos asignados correctamente!");
    } catch (error) {
      toast.error("¡Error al asignar los grupos!");
      console.error("Error al asignar los grupos", error);
    }
  };




  const linkPublico = () => {
    window.open(
      `https://resultados.hayllis.com/torneos/${idevent}/sports/${idsport}/sport`,
      "_blank"
    );
  };

  const handleRandomSembradoRegion = async () => {
    let regions;
    let groupCount;
    try {
      if (customRegions) {
        const parsedConfig = parseInputToRegions(customRegions);
        if (!parsedConfig) return; // Si hay error, detener la ejecución
        regions = parsedConfig.regions;
        groupCount = parsedConfig.groupCount;
        setGroupSizes(new Array(groupCount).fill(0)); // Actualizar los tamaños de los grupos según el nuevo input
      } else {
        regions = [
          { idregion: 1, name: "Lima", total: 7, heads: 1 },
          { idregion: 2, name: "Sur", total: 5, heads: 2 },
          { idregion: 3, name: "Norte", total: 5, heads: 1 },
          { idregion: 4, name: "Centro", total: 2, heads: 1 },
        ];
        groupCount = 6; // Valor predeterminado o definido de otra manera
      }
    } catch (error) {
      toast.error("Error al parsear la configuración personalizada.");
      return;
    }

    try {
      if (Number(idsport) === 42) {
        await randomSembradoEspecialFutbolDamas(idevent, idsport);
      } else {
        await randomSembradoRegion(idevent, idsport, regions, groupSizes);
      }
      setSembradoUpdated(!sembradoUpdated); // Alternar el estado para forzar actualización
    } catch (error) {
      console.error("Error al generar el sembrado regional", error);
    }
  };

  const parseInputToRegions = (input) => {
    try {
      const [totals, heads, groupCountStr] = input.split(";");

      // Convertir las cadenas en arrays de números
      const totalArray = totals.split(",").map(Number);
      const headsArray = heads.split(",").map(Number);
      const groupCount = Number(groupCountStr);

      // Verificar que las entradas sean válidas
      if (
        totalArray.length !== 4 ||
        headsArray.length !== 4 ||
        isNaN(groupCount)
      ) {
        throw new Error("Formato incorrecto de entrada.");
      }

      // Convertir las entradas en el formato de regiones
      const regions = [
        {
          idregion: 1,
          name: "Lima",
          total: totalArray[0],
          heads: headsArray[0],
        },
        {
          idregion: 2,
          name: "Sur",
          total: totalArray[1],
          heads: headsArray[1],
        },
        {
          idregion: 3,
          name: "Norte",
          total: totalArray[2],
          heads: headsArray[2],
        },
        {
          idregion: 4,
          name: "Centro",
          total: totalArray[3],
          heads: headsArray[3],
        },
      ];

      return { regions, groupCount };
    } catch (error) {
      toast.error(
        "Error al parsear la configuración personalizada. Asegúrate de que esté en el formato correcto."
      );
      console.error("Error al parsear la configuración de entrada:", error);
      return null;
    }
  };

  return (
    <>
      <div className="modal_x font-quickSand">
        <Modal
          open={open}
          onClose={() => {
            setOpen(false);
          }}
        >
          <ModalDialog layout="fullscreen">
            <ModalClose sx={{ width: "35px" }} />
            <DialogTitle>Fase de Grupos - {sport && sport.name}</DialogTitle>
            <DialogContent>
              <div
                className="w-full text-white py-3 text-center text-2xl font-bold"
                style={{
                  backgroundColor: color,
                  borderRadius: "8px",
                }}
              >
                <span
                  style={{
                    fontSize: "2.5rem",
                  }}
                >
                  {Number(idevent) === 150 || Number(idevent) === 1
                    ? "PARTICIPANTES / PARTICIPANTS"
                    : "INSTITUCIONES PARTICIPANTES"}
                </span>
              </div>
              <div>
                {Number(idevent) === 50 ? (
                  <ParticipantesRugby config={configCtg} />
                ) : event ? (
                  event.tipoAlcance === 2 ? (
                    <Regionales2 config={configCtg} />
                  ) : (
                    <Regionales config={configCtg} />
                  )
                ) : null}
              </div>
              {/* {Number(idsport) !== 56 ? ( */}
              {Number(idsport) !== 99999 ? (
                <>
                  <div
                    className="w-full text-white py-3 text-center text-2xl font-bold mt-4 relative"
                    style={{
                      backgroundColor: color,
                      borderRadius: "8px",
                    }}
                  >
                    <FaExternalLinkAlt
                      className="icon-diagonal-hover"
                      onClick={() => linkPublico()}
                    />
                    {configCtg.useSembradoRegional && (
                      <>
                        <FaObjectGroup
                          className="icon-hover icon-expand-hover"
                          style={{ left: '75px', fontSize: '2rem' }}
                          onClick={handleAssignRandomGroupSizes}
                        />

                        <GiPerspectiveDiceSixFacesRandom
                          className="icon-hover"
                          style={{ left: '120px', fontSize: '2.5rem' }}
                          onClick={handleRandomSembradoRegion}
                        />

                        <FaDatabase
                          className="icon-hover"
                          style={{ left: '175px', fontSize: '2rem' }}
                          onClick={handleCustomConfigOpen}
                        />
                      </>
                    )}

                    <span
                      className="cursor-pointer hover:underline"
                      style={{
                        fontSize: "2.5rem",
                      }}
                      onClick={handleConfirmOpen}
                    >
                      {Number(idevent) === 150 || Number(idevent) === 1
                        ? "GRUPOS / GROUPS"
                        : "GRUPOS"}
                    </span>
                    {configCtg.isRandom && (
                      <FaWandMagicSparkles
                        className="magic-sparkle-icon"
                        style={{
                          position: "absolute",
                          right: "25px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "2rem",
                          cursor: "pointer",
                        }}
                        onClick={() => assignRandomGroups()}
                      />
                    )}
                  </div>
                  <div>
                    <Grupos
                      config={configCtg}
                      participantes={participantes}
                      setParticipantes={setParticipantes}
                      sembradoUpdated={sembradoUpdated} // Pasar el estado a Grupos
                      groupSizes={groupSizes}
                      setGroupSizes={setGroupSizes}
                    />
                  </div>
                </>
              ) : null}
              {/* <div
                className="w-full text-white p-4 text-center text-2xl font-bold mt-4"
                style={{
                  backgroundColor: color,
                  borderRadius: "8px",
                  fontSize: "2.5rem",
                }}
              >
                FIXTURE
              </div>
              <div>
                {Number(idevent) === 50 && Number(idsport) === 56 && (
                  <Fixture />
                )}
                {Number(idevent) === 50 && Number(idsport) === 57 && flag6 && (
                  <Fixture2 />
                )}
                {Number(idevent) === 50 && Number(idsport) === 57 && !flag6 && (
                  <Fixture3 />
                )}
              </div> */}
            </DialogContent>
          </ModalDialog>
        </Modal>
      </div>

      <Modal open={confirmOpen} onClose={handleConfirmClose}>
        <ModalDialog>
          <ModalClose />
          <DialogTitle>Confirmación</DialogTitle>
          <DialogContent>
            <p>¿Está seguro de generar los enfrentamientos?</p>
            <div className="flex justify-end gap-2 mt-4">
              <Button variant="plain" onClick={handleConfirmClose}>
                No
              </Button>
              <Button
                variant="solid"
                onClick={() => {
                  generateMatches();
                  handleConfirmClose();
                }}
              >
                Sí
              </Button>
            </div>
          </DialogContent>
        </ModalDialog>
      </Modal>

      {/* Modal para configuración personalizada */}
      <Modal open={customConfigOpen} onClose={handleCustomConfigClose}>
        <ModalDialog sx={{ width: "40vw", maxWidth: "none" }}>
          <ModalClose />
          <DialogTitle>Configurar Sembrado</DialogTitle>
          <DialogContent>
            <input
              type="text"
              className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={customRegions} // Mostrar el valor como cadena
              onChange={(e) => setCustomRegions(e.target.value)} // Guardar la cadena
              placeholder="6,8,4,2;2,2,1,1;6"
            />
            <div className="flex justify-end gap-2 mt-4">
              <Button variant="plain" onClick={handleCustomConfigClose}>
                Cancelar
              </Button>
              <Button variant="solid" onClick={handleSaveCustomConfig}>
                Guardar
              </Button>
            </div>
          </DialogContent>
        </ModalDialog>
      </Modal>

      {/* <Modal open={confirmOpen} onClose={handleConfirmClose}>
        <ModalDialog>
          <ModalClose />
          <DialogTitle>Confirmación</DialogTitle>
          <DialogContent>
            <p>¿Está seguro de generar los enfrentamientos?</p>
            <div className="flex justify-end gap-2 mt-4">
              <Button variant="plain" onClick={handleConfirmClose}>
                No
              </Button>
              <Button
                variant="solid"
                onClick={() => {
                  generateMatches();
                  handleConfirmClose();
                }}
              >
                Sí
              </Button>
            </div>
          </DialogContent>
        </ModalDialog>
      </Modal> */}
    </>
  );
};

export default FullScreenGrupos;
